import React, { useRef, useEffect, useState } from "react";
import "./upload-image.scss";
import uploadImageIcon from "../../../assets/icons/upload-image.svg";
import CancelIcon from "@mui/icons-material/Cancel";

interface UploadImageProps {
  label: string;
  text: string;
  onChange: (file: any) => void;
  value: any;
  onClick?: any;
  showCloseButton?: boolean;
  handleClose?: () => void;
  fieldName?: string;
  isPreviewImage?:boolean;
}

const UploadImage: React.FC<UploadImageProps> = ({
  label,
  text,
  onChange,
  value,
  onClick,
  showCloseButton = false,
  handleClose,
  fieldName,
  isPreviewImage,
}) => {
  const [preview, setPreview] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event?.target?.files?.[0] || null;
    if (file) {
      const objectUrl = URL.createObjectURL(file);
      setPreview(objectUrl); // set preview immediately
      onChange(file);        // update formik
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const file = event.dataTransfer.files?.[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleRemoveFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    if (handleClose) handleClose();
    setPreview(null);
  };

  useEffect(() => {
    if (value && isPreviewImage !== false) {
      setPreview(URL.createObjectURL(value));
    } else {
      setPreview(null);
    }
  }, [value, isPreviewImage]);

  return (
    <div
      className="upload-container"
      onDrop={handleDrop}
      onDragOver={(e) => e.preventDefault()}
    >
      <label htmlFor="fileInput" className="upload-label">
        {label}
      </label>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        name={fieldName}
        onChange={handleFileChange}
        className="file-input"
        onClick={(e) => {
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          if (onClick) onClick(e);
        }}
        id="fileInput"
        hidden
      />

      {preview ? (
        <div className="preview-container">
          <div className="image-wrapper">
            <img src={preview} alt="Preview" className="preview-image" />
            {showCloseButton && (
              <div className="close-image" onClick={handleRemoveFile}>
                <CancelIcon fontSize="small" className="cancel-icon" />
              </div>
            )}
          </div>
        </div>
      ) : (
        <label htmlFor="fileInput" className="upload-content">
          <img src={uploadImageIcon} className="image-icon" alt="Upload Icon" />
          <p className="upload-text">Upload {text} +</p>
        </label>
      )}
    </div>
  );
};

export default UploadImage;
